import { Utils } from "@/plugins/utils"
import Vue from "vue"
import moment from "moment"

export default {
	namespaced: true,
	state: {
		lstMeb: [],
		mapMec: {},
		mapMee: {},
		mebsince: moment().subtract(1, "day").startOf("day").toISOString(),
		mebuntil: moment().endOf("day").toISOString(),
		availableOpercoms: {},
		meb: null,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		onlyWithDocs: false,
		statusesToFilterList: [],
		insert: false,
		update: false,
		mapToAddMec: {},
		mapToDeleteMec: {},
		mapToAddMee: {},
		mapToDeleteMee: {},
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getMeb(state) {
			let meb = { ...state.meb }
			meb.mebdata = meb.mebdata ? meb.mebdata : new Date(1900, 1, 1)
			return meb
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
	},
	mutations: {
		setMeb(state, meb) {
			state.meb = meb
		},
		initForm(state) {
			state.meb = null
			state.mapMec = {}
			state.mapMee = {}
			state.mapToAddMec = {}
			state.mapToDeleteMec = {}
			state.mapToAddMee = {}
			state.mapToDeleteMee = {}
		},
		initSearchForm(state) {
			state.lstMeb = []
		},
		setParamsDataTable(state, payload) {
			state.lstMeb = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setLstMeb(state, lst) {
			state.lstMeb = lst
		},
		setMapMec(state, map) {
			state.mapMec = map
		},
		setMapMee(state, map) {
			state.mapMee = map
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setSearch(state, search) {
			state.search = search
		},

		addToMapToAddMec(state, { key, value }) {
			if (!state.mapMec[key]) {
				Vue.set(state.mapToAddMec, key, value)
			}
		},

		addToMapToRemoveMec(state, { key, value }) {
			Vue.set(state.mapToDeleteMec, key, value)
		},

		addToMapToAddMee(state, { key, value }) {
			if (!state.mapMee[key]) {
				Vue.set(state.mapToAddMee, key, value)
			}
		},

		addToMapToRemoveMee(state, { key, value }) {
			Vue.set(state.mapToDeleteMee, key, value)
		},

		removeFromMapToAddMec(state, { key }) {
			Vue.delete(state.mapToAddMec, key)
		},

		removeFromMapToRemoveMec(state, { key }) {
			Vue.delete(state.mapToDeleteMec, key)
		},

		removeFromMapToAddMee(state, { key }) {
			Vue.delete(state.mapToAddMee, key)
		},

		removeFromMapToRemoveMee(state, { key }) {
			Vue.delete(state.mapToDeleteMee, key)
		},

		buildMebPayload(state, { mebrepres, mebcliente, mebobserva, mebenderid }) {
			state.meb.mebcliente = mebcliente
			state.meb.mebrepres = mebrepres
			state.meb.mebobserva = mebobserva
			state.meb.mebenderid = mebenderid

			state.meb.lstmectoadd = Object.values(state.mapToAddMec)
			state.meb.lstmectodelete = Object.values(state.mapToDeleteMec)

			state.meb.lstmeetoadd = Object.values(state.mapToAddMee)
			state.meb.lstmeetodelete = Object.values(state.mapToDeleteMee)
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async find({ commit, dispatch }, params) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(
					`/Oryxplace/CylinderMovement/Find?mebDocLei=${params.mebdoclei}&mebTipo=${params.mebtipo}&mebEmissor=${params.mebemissor}&mebSubseri=${params.mebsubseri}`,
				)
				.then(response => {
					let meb = Utils.ValidateAxiosResponse(response.data)
					commit("setMeb", meb)
					return meb
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		async canRemoveMec({ commit, dispatch, state }, { containerId }) {
			commit("setLoading", true)

			let payload = await this._vm.$axios
				.post(`/Oryxplace/CylinderMovement/CanDeleteMec?containerId=${containerId}`, state.meb)
				.then(response => {
					try {
						return Utils.ValidateAxiosResponse(response.data)
					} catch (error) {
						return error.message
					}
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async canRemoveMee({ commit, dispatch, state }, { containerId }) {
			commit("setLoading", true)

			let payload = await this._vm.$axios
				.post(`/Oryxplace/CylinderMovement/CanDeleteMee?containerId=${containerId}`, state.meb)
				.then(response => {
					try {
						return Utils.ValidateAxiosResponse(response.data)
					} catch (error) {
						return error.message
					}
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async search({ commit, getters, dispatch, state }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initSearchForm")

			let query = `/Oryxplace/CylinderMovement/Search?search=${getters.getSearch}&limit=${limit}&page=${page}&onlyWithDocs=${state.onlyWithDocs}`

			if (state.statusesToFilterList.length > 0) {
				for (const status of state.statusesToFilterList) {
					query += `&statuses=${encodeURIComponent(status)}`
				}
			}

			if (state.mebsince != "" && state.mebsince != null) {
				query += `&startDate=${encodeURIComponent(new Date(state.mebsince).toISOString())}`
			}
			if (state.mebuntil != "" && state.mebuntil != null) {
				query += `&endDate=${encodeURIComponent(new Date(state.mebuntil).toISOString())}`
			}

			let payload = await this._vm.$axios
				.get(query)
				.then(async response => {
					let data = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", data)
					return true
				})
				.catch(error => {
					commit("setLstMeb", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		async findMecList({ commit, dispatch, state }) {
			commit("setLoading", true)
			await this._vm.$axios
				.post(`/Oryxplace/CylinderMovement/FindExits`, state.meb)
				.then(response => {
					const list = Utils.ValidateAxiosResponse(response.data)
					const objMap = list.reduce((acc, item) => {
						acc[item.mecidrecip] = item
						return acc
					}, {})
					commit("setMapMec", objMap)
				})
				.catch(error => {
					commit("setMapMec", {})
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		async findMeeList({ commit, dispatch, state }) {
			commit("setLoading", true)
			await this._vm.$axios
				.post(`/Oryxplace/CylinderMovement/FindEntries`, state.meb)
				.then(response => {
					const list = Utils.ValidateAxiosResponse(response.data)
					const objMap = list.reduce((acc, item) => {
						acc[item.meeidrecip] = item
						return acc
					}, {})
					commit("setMapMee", objMap)
				})
				.catch(error => {
					commit("setMapMee", {})
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		async getMecRecip({ commit, dispatch, state }, containerId) {
			commit("setLoading", true)

			state.meb.lstmectoadd = Object.values(state.mapToAddMec)
			state.meb.lstmectodelete = Object.values(state.mapToDeleteMec)

			state.meb.lstmeetoadd = Object.values(state.mapToAddMee)
			state.meb.lstmeetodelete = Object.values(state.mapToDeleteMee)

			return await this._vm.$axios
				.post(`/Oryxplace/CylinderMovement/GetMecRecip?containerId=${containerId}`, state.meb)
				.then(response => {
					const data = Utils.ValidateAxiosResponse(response.data)
					if (data.errors && Object.keys(data.errors).length > 0) {
						const errorMessages = Object.entries(data.errors)
							.map(([field, message]) => `Erro ao adicionar o recipiente ${field}: ${message}\n`)
							.join("\n")

						dispatch(
							"parameters/openDialog",
							{
								titleText: "Erro",
								titleColor: "red",
								text: errorMessages,
							},
							{ root: true },
						)
					}
					return data.mecbasket
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
				.finally(() => {
					commit("setLoading", false)
				})
		},
		async getMeeRecip({ commit, dispatch, state }, containerId) {
			commit("setLoading", true)

			state.meb.lstmectoadd = Object.values(state.mapToAddMec)
			state.meb.lstmectodelete = Object.values(state.mapToDeleteMec)

			state.meb.lstmeetoadd = Object.values(state.mapToAddMee)
			state.meb.lstmeetodelete = Object.values(state.mapToDeleteMee)

			return await this._vm.$axios
				.post(`/Oryxplace/CylinderMovement/GetMeeRecip?containerId=${containerId}`, state.meb)
				.then(response => {
					const data = Utils.ValidateAxiosResponse(response.data)
					if (data.errors && Object.keys(data.errors).length > 0) {
						const errorMessages = Object.entries(data.errors)
							.map(([field, message]) => `Erro ao adicionar o recipiente ${field}: ${message}`)
							.join("\n")

						dispatch(
							"parameters/openDialog",
							{
								titleText: "Erro",
								titleColor: "red",
								text: errorMessages,
							},
							{ root: true },
						)
					}
					return data.meebasket
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
				.finally(() => {
					commit("setLoading", false)
				})
		},
		async handleMebResponse({ commit, dispatch, state }, model) {
			if (model.errors) {
				commit("setLoading", false)
				if (model.errors.fatalerror) {
					await dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: model.errors.fatalerror,
						},
						{ root: true },
					)
					return false
				}
				if (model.errors.errordictmec) {
					await dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: `Erro ao tentar salvar o documento:\n\n${model.errors.errordictmec}`,
						},
						{ root: true },
					)
					return false
				}
				if (model.errors.errordictmee) {
					await dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: `Erro ao tentar salvar o documento:\n\n${model.errors.errordictmee}`,
						},
						{ root: true },
					)
					return false
				}
			}

			if (model.success) {
				commit("setMeb", model.payload)
			}
			return model
		},
		async insert({ commit, getters, dispatch, state }, mebModel = null) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)

			const data = mebModel || state.meb

			let payload = await this._vm.$axios
				.post("/OryxPlace/CylinderMovement/Insert", data)
				.then(async response => {
					let meb = Utils.ValidateAxiosResponse(response.data)
					await dispatch("handleMebResponse", meb)
					return meb
				})
				.catch(async error => {
					await dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error?.message || "Erro ao inserir movimentação",
						},
						{ root: true },
					)
					return false
				})

			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: false, text: "" },
				{ root: true },
			)

			return payload
		},


		async update({ commit, getters, dispatch, state }, mebModel = null) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Atualizando", indeterminate: true },
				{ root: true },
			)

			const data = mebModel || state.meb

			let payload = await this._vm.$axios
				.post("/OryxPlace/CylinderMovement/Update", data)
				.then(async response => {
					let meb = Utils.ValidateAxiosResponse(response.data)
					await dispatch("handleMebResponse", meb)
					return meb
				})
				.catch(async error => {
					await dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error?.message || "Erro ao atualizar movimentação",
						},
						{ root: true },
					)
					return false
				})

			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: false, text: "" },
				{ root: true },
			)

			return payload
		},

		async saveMeb({ commit, dispatch, state }, { mebrepres, mebcliente, mebobserva, mebenderid }) {
			if (!state.meb) {
				dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: "Movimentação não pode estar com a operação vazia",
					},
					{ root: true },
				)
				return false
			}

			commit("buildMebPayload", { mebrepres, mebcliente, mebobserva, mebenderid })


			if (state.update) {
				return await dispatch("update")
			}
			
			return await dispatch("insert")

		},

		async createMebFromSubseri({ commit, dispatch, state }, { mebrepres, mebcliente }) {
			if (state.meb == null) {
				dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: "Movimentação não pode estar vazia",
					},
					{ root: true },
				)
				return
			}

			state.meb.mebcliente ??= mebcliente
			state.meb.mebrepres ??= mebrepres

			state.meb.lstmectoadd = Object.values(state.mapToAddMec)
			state.meb.lstmectodelete = Object.values(state.mapToDeleteMec)

			state.meb.lstmeetoadd = Object.values(state.mapToAddMee)
			state.meb.lstmeetodelete = Object.values(state.mapToDeleteMee)

			commit("setLoading", true)

			try {
				const response = await this._vm.$axios.post(`/Oryxplace/CylinderMovement/CreateMebFromSubseri`, state.meb)
				commit("initForm")

				state.meb = Utils.ValidateAxiosResponse(response.data)

				return true
			} catch (error) {
				dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
				return false
			} finally {
				commit("setLoading", false)
			}
		},
		async deleteMeb({ commit, dispatch, state }) {
			commit("setLoading", true)
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Cancelando", indeterminate: true },
				{ root: true },
			)
			try {
				const response = await this._vm.$axios.post(`/Oryxplace/CylinderMovement/Delete`, state.meb)
				const data = response.data
				if (data.isError) {
					throw Error(data.messageError)
				}

				const model = data.objectModel
				if (model.errors != null) {
					if (model.errors.fatalerror) {
						dispatch(
							"parameters/openDialog",
							{
								titleText: "Erro",
								titleColor: "red",
								text: `As seguintes ações deverão ser tomadas para cancelar esse documento:\n\n${model.errors.fatalerror}`,
							},
							{ root: true },
						)
						return
					}
					if (model.errors.errordictmec) {
						dispatch(
							"parameters/openDialog",
							{
								titleText: "Erro",
								titleColor: "red",
								text: `As seguintes ações deverão ser tomadas para cancelar esse documento:\n\n${model.errors.errordictmec}`,
							},
							{ root: true },
						)
						return
					}
					if (model.errors.errordictmee) {
						dispatch(
							"parameters/openDialog",
							{
								titleText: "Erro",
								titleColor: "red",
								text: `As seguintes ações deverão ser tomadas para cancelar esse documento:\n\n${model.errors.errordictmee}`,
							},
							{ root: true },
						)
						return
					}
				}
				if (model.success) {
					await dispatch("search", { limit: state.itemsPerPage })
				}
				return model
			} catch (error) {
				dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
			} finally {
				dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
				commit("setLoading", false)
			}
		},
		async getMebOnOpercom({ commit, dispatch, state }, opercom) {
			commit("setLoading", true)

			if (state.meb == null) {
				commit("initForm")
			} else {
				if (state.meb.mebopercom != opercom) {
					commit("initForm")
				}
			}

			return await this._vm.$axios
				.get(`/Oryxplace/CylinderMovement/GetMebOnOpercom?opercom=${opercom}`)
				.then(response => {
					const meb = Utils.ValidateAxiosResponse(response.data)
					state.meb = { ...meb, ...state.meb }
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
				.finally(() => {
					commit("setLoading", false)
				})
		},

		async printReportRecipientMovement({ dispatch, commit }, object) {
			commit("setLoading", true)
			return await this._vm.$axios
				.post(`/Oryxplace/CylinderMovement/PrintReportRecipientMovement`, object)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
				.finally(() => {
					commit("setLoading", false)
				})
		},
		async findAllMebopercom({ commit, state, dispatch }) {
			commit("setLoading", true)
			return await this._vm.$axios
				.get(`/Oryxplace/CylinderMovement/FindAllMebopercom`)
				.then(response => {
					const list = Utils.ValidateAxiosResponse(response.data)
					for (const item of list) {
						state.availableOpercoms[item.cv3opercom] = item
					}
					return list
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return []
				})
				.finally(() => {
					commit("setLoading", false)
				})
		},
		async findAllDocuments({ commit, dispatch }, meb) {
			commit("setLoading", true)
			return await this._vm.$axios
				.get(
					`/Oryxplace/CylinderMovement/FindAllCv5sRelatedToMeb?mebDocLei=${meb.mebdoclei}&mebTipo=${meb.mebtipo}&mebEmissor=${meb.mebemissor}&mebSubseri=${meb.mebsubseri}`,
				)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return []
				})
				.finally(() => {
					commit("setLoading", false)
				})
		},

	async searchCv5ToMeb(
			{ commit, dispatch },
			{ search = "", limit = 20, page = 1 } = {}
		) {
			commit("setLoading", true)

			try {
				const response = await this._vm.$axios.get(
					`/Oryxplace/CylinderMovement/SearchCv5ToMeb?search=${search}&limit=${limit}&page=${page}`
				)

				const result = Utils.ValidateAxiosResponse(response.data)
				return result.items
			} catch (error) {
				dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true }
				)

				return []
			} finally {
				commit("setLoading", false)
			}
		}
	},
}
